/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const DonutChartSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g><path d="M11 5.66c0 .244-.177.45-.415.508a6.002 6.002 0 0 0-4.34 7.536.53.53 0 0 1-.232.613l-2.649 1.53a.48.48 0 0 1-.691-.233A9.975 9.975 0 0 1 2 12c0-4.996 3.664-9.137 8.452-9.88A.48.48 0 0 1 11 2.6V5.66ZM17.99 14.304a.53.53 0 0 1-.232-.612 6.002 6.002 0 0 0-4.343-7.524A.531.531 0 0 1 13 5.66V2.6a.48.48 0 0 1 .548-.482C18.336 2.863 22 7.004 22 12c0 1.27-.236 2.483-.668 3.6a.48.48 0 0 1-.691.234l-2.65-1.53ZM16.99 16.035a.53.53 0 0 0-.647.105A5.983 5.983 0 0 1 12 18a5.983 5.983 0 0 1-4.335-1.851.53.53 0 0 0-.645-.104l-2.65 1.53a.48.48 0 0 0-.143.717A9.98 9.98 0 0 0 12 22a9.98 9.98 0 0 0 7.782-3.719.48.48 0 0 0-.144-.716l-2.649-1.53Z" /></g></svg>);
const DonutChartSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={DonutChartSolidBase} {...rest} ref={ref} />);
export default DonutChartSolid;